import { takeLatest, call, put } from 'redux-saga/effects'
import lessonBlocksList from 'api/administration/blocks/List'
import { editScormBlock } from 'api/administration/blocks/Edit'
import I18n from 'i18n'
import { SuccessToast, ErrorToast } from 'components/ui/toast/toastsTemplates'
import * as fromActions from '../../../actions/blocks.action'

async function getList(lessonId: number) {
  return lessonBlocksList(lessonId)
}
async function editScorm(blockId: number, blockDetails: any) {
  return editScormBlock(blockId, blockDetails)
}

function* editScormBlockEffectSaga(action: any) {
  try {
    const {
      payload: {
        id,
        lessonId,
        description,
        name,
        showTitle,
        file,
        openNewWindow,
        blockAdvance,
      },
    } = action

    const blockDetails = {
      block_scorm: {
        show_title: showTitle,
        file: null,
        openNewWindow,
        blockAdvance,
      },
      block_instance: {
        name,
        description,
        lesson_id: lessonId,
      },
    }
    if (file.id) {
      // @ts-ignore
      blockDetails.block_scorm.file = file
    }
    yield call(editScorm, id, blockDetails)
    const data = yield call(getList, lessonId)
    yield put(fromActions.Actions.getLessonBlocksListSuccess(data))
    SuccessToast(I18n.t('administration.toastMessages.editSuccess'))
  } catch (error) {
    yield put(fromActions.Actions.setLoading(false))
    ErrorToast(I18n.t('administration.toastMessages.editError'))
    console.log('error: ', error)
  }
}

export function* editScormBlockWatcherSaga() {
  yield takeLatest(fromActions.EDIT_SCORM_BLOCK, editScormBlockEffectSaga)
}
